// extracted by mini-css-extract-plugin
export default {"description":"DateTimeInputDialog_description__5lX1T"};